import React from 'react';
import styled from './index.module.scss';
import { useQuestionStore } from 'lowcomp/plugins/member/member-questions/content/components/QuestionProvider';
import NextImage from '@/components/NextImage';
import { useGlobal } from '@/utils/useGlobal';
import Button from '@/components/UI/Button';
import { textLang } from '../../textLang';
import EcoImg from 'eco-design/base/eco-img';

interface FinshedProps {
    lookBack: () => void;
}

const commuityUrl: Record<string, string> = {
    de: 'https://bit.ly/3ueKhW4',
    fr: 'https://bit.ly/48YdFio',
    it: 'https://bit.ly/42p5YPC',
};

const Finshed: React.FC<FinshedProps> = ({ lookBack }) => {
    const { useLang, useRouter, Link } = useGlobal();
    const { rewardTotalPoints } = useQuestionStore();
    const { t } = useLang('appreciationday');
    const { locale } = useRouter();
    const lang = textLang[locale as string] || textLang.us;

    return (
        <div className={styled.finshed}>
            <h6 className="title">{lang.finshed_title}</h6>
            <div className="imgbox">
                <EcoImg pc="https://websiteoss.ecoflow.com/upload/image/1773901537288/premium.jpg" alt={lang.welcome} aria-label={lang.welcome} />
            </div>
            <p className="subtitle">{lang.rewards}</p>
            <p className="number">{rewardTotalPoints}</p>
            <p className="tips">{lang.ecoCredits}</p>
            <Button className="look_back" aria-label={''} onClick={lookBack}>
                {lang.view_answer}
            </Button>
            {['de', 'fr', 'it'].includes(locale) && (
                <Link href={commuityUrl[locale]} target="_blank">
                    <Button className="joinus_btn" aria-label={''}>
                        {lang.join_community_btn}
                    </Button>
                </Link>
            )}
        </div>
    );
};

export default Finshed;
